import React, { useEffect, useReducer } from "react";
//import styles from '../assets/reports.module.scss'
import {ReportsBodyLeft} from '../common/reports.body.left.js';
import { ReportsBodyRight} from '../common/reports.body.right.js';
import  { Heading } from '../common/heading.module.js';
import  {Selling} from '../common/selling.js';

// Interface for search data
interface SearchData {
	token: string;
	discovered?: number;
	completed?: boolean;
	max?: number;
	list?: wts_ignore_any[];
}

// Interface for component state
interface ReportsBodyState {
	searchToken: string;
	searchDiscovered: number;
	searchMax: number;
	searchCompleted: boolean;
	searchList: wts_ignore_any[];
}

// Interface for component props
interface ReportsBodyProps {
	allowPurchases?: boolean;
}

const ReportsBodyReducer = function( state: ReportsBodyState, [ type, data ]: [string, SearchData] ): ReportsBodyState {

	if( type === "search" ){
		return {
			...state,
			searchToken: data.token,
			searchDiscovered: data.discovered || 0,
			searchCompleted: data.completed || false,
			searchMax: data.max || 0,
			searchList: data.list || [],
		};
	};

	return state;
};

export const RangeComma = ( value: number | string ): string => {

	if( !value )
		return "0";

	let source = value.toString();
	let string = "";
	let m = 0;

	for( let n = source.length; n > 0; n--, m++ ){

		if( m && !(m % 3) )
			string += ",";

		string += source[ n - 1 ];
	};

	return string.split( "" ).reverse().join( "" );
};

export const ReportsBody = ( props: ReportsBodyProps ) => {

	const [ state, dispatch ] = useReducer( ReportsBodyReducer, {
		searchToken: "",
		searchDiscovered: 0,
		searchMax: 5000,
		searchCompleted: false,
		searchList: []
	});

	return (
		<section className={ "reports-body" }>

			<ReportsBodyLeft dispatch={ dispatch }/>

			<ReportsBodyRight>
				<Heading
					heading={"Discovered Domains"}
					headingDescription={"Total  discovered: "
						+ (state.searchDiscovered > state.searchMax ?
							("More then " + RangeComma( state.searchMax ))
							:
							RangeComma( state.searchDiscovered ) )
					}
				/>
				<Selling
					tools={ true }
					max={ state.searchMax }
					list={ state.searchList }
					discovered={ state.searchDiscovered }
					completed={ state.searchCompleted }
					allowPurchases={ props.allowPurchases }
				/>
			</ReportsBodyRight>

		</section>
	);
};